import React, { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom";

import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/Search';
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import MailIcon from "@mui/icons-material/Mail";
import Paper from "@mui/material/Paper";

export function Menu() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('');

    useEffect(() => {
        const pathname = location.pathname;
        if (pathname.startsWith('/reservations')) {
            setActiveTab('reservations');
        } else if (pathname.startsWith('/inbox')) {
            setActiveTab('inbox');
        } else if (pathname.startsWith('/profile')) {
            setActiveTab('profile');
        } else {
            setActiveTab('');
        }
    }, [location.pathname]);

    return(
        <Paper sx={{ position: 'fixed !important', bottom: 0, width: '100%', zIndex: 999 }} elevation={3}>
            <BottomNavigation showLabels value={activeTab}>
                <BottomNavigationAction
                    sx={{ minWidth: '60px', padding: 0 }}
                    label={<div style={{ fontSize: '11px' }}>Поиск</div>}
                    value="search"
                    onClick={() => {
                        const basicUrl = window.location.protocol === 'https:' 
                            ? `${process.env.REACT_APP_BASIC}/`
                            : `${process.env.REACT_APP_LOCAL_BASIC}/`;
                        window.location.href = basicUrl;
                    }}
                    icon={<SearchIcon />}
                />
                <BottomNavigationAction
                    sx={{ minWidth: '60px', padding: 0 }}
                    label={<div style={{ fontSize: '11px' }}>Избранные</div>}
                    value="wishlists"
                    onClick={() => {
                        const basicUrl = window.location.protocol === 'https:' 
                            ? `${process.env.REACT_APP_BASIC}/account/wishlists`
                            : `${process.env.REACT_APP_LOCAL_BASIC}/account/wishlists`;
                        window.location.href = basicUrl;
                    }}
                    icon={<FavoriteIcon />}
                />
                <BottomNavigationAction
                    sx={{ minWidth: '60px', padding: 0 }}
                    label={<div style={{ fontSize: '11px' }}>Поездки</div>}
                    value="reservations"
                    onClick={() => navigate(`/reservations`)}
                    icon={<LocalTaxiIcon />}
                />
                <BottomNavigationAction
                    sx={{ minWidth: '60px', padding: 0 }}
                    label={<div style={{ fontSize: '11px' }}>Входящие</div>}
                    value="inbox"
                    onClick={() => navigate(`/inbox`)}
                    icon={<MailIcon />}
                />
                <BottomNavigationAction
                    sx={{ minWidth: '60px', padding: 0 }}
                    label={<div style={{ fontSize: '11px' }}>Профиль</div>}
                    value="profile"
                    onClick={() => navigate(`/profile`)}
                    icon={<AccountCircleIcon />}
                />
            </BottomNavigation>
        </Paper>
    )
}